import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import useLineLiff from 'hooks/LineLiff';
import { loginComplete } from './LoginAction';

import 'pages/toyotaOfficialAccount/toyota-namespace.css';
import Loading from 'pages/toyotaOfficialAccount/Loading';

const LoginCallbackPage = () => {
  const navigate = useNavigate();
  const lineOAName = process.env.REACT_APP_LINE_OA_NAME;
  const [searchParams] = useSearchParams();

  const { liff, userInfo, status, setStatus, errorMsg, setErrorMsg } =
    useLineLiff(process.env.REACT_APP_LIFF_ID_LOGIN_CALLBACK);

  useEffect(() => {
    if (!userInfo) return;
    const idToken = liff.getIDToken();

    const fetchLoginComplete = async () => {
      try {
        setStatus('Completing login...');

        const result = await loginComplete(
          idToken,
          searchParams.get('memberSeq'),
          searchParams.get('code')
        );
        setStatus(`Login ${result.success ? 'successful' : 'failed'}`);
        if (result.success) {
          let redirectUrl = searchParams.get('redirectUrl');
          if (redirectUrl) {
            try {
              redirectUrl = atob(redirectUrl);
            } catch (err) {
              console.warn('Error decoding redirectUrl:', err);
              redirectUrl = null;
            }
          }

          if (result.data?.redirect_url) {
            window.location.href = result.data.redirect_url;
          } else {
            window.location.href =
              redirectUrl || process.env.REACT_APP_LEXUS_LINE_URL;
          }
        } else {
          if (lineOAName === 'TOYOTA') {
            if (result.data?.redirect_url) {
              window.location.href = result.data.redirect_url;
            } else {
              navigate('/hotai/toyota/binding-fail');
            }
          } else {
            if (result.data?.message) {
              alert(result.data.message);
            } else {
              alert('Login failed. Please try again.');
            }
            liff.closeWindow();
          }
        }
      } catch (err) {
        if (lineOAName === 'TOYOTA') navigate('/hotai/toyota/binding-fail');
        setErrorMsg(`error occurred while fetching data: ${err.message}`);
      }
    };

    fetchLoginComplete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, userInfo]);

  if (lineOAName === 'TOYOTA') {
    return (
      <div className="toyota-webview">
        <Loading />
      </div>
    );
  } else if (errorMsg || status) {
    return <div>{errorMsg ? errorMsg : status}</div>;
  }

  return (
    <div>
      <h1>Callback from Hotai Login</h1>
      <ul>
        <li>Code: {searchParams.get('code')}</li>
        <li>Member Seq: {searchParams.get('memberSeq')}</li>
      </ul>
    </div>
  );
};

export default LoginCallbackPage;
